import SuperFetch from '../../../superFetch.js';

class CsReviewApi {
  /**
   *  [상품 후기 상세] 태그 리스트 전체 엑셀 다운로드
   */
  getCsReviewDetailTagAllListDownload = (data) => SuperFetch.post('/cs/review/detail/tag/list/excel/download', data);

  /**
   *  [상품 후기 상세] 태그 리스트 선택 엑셀 다운로드
   */
  getCsReviewDetailTagSelectedListDownload = (data) =>
    SuperFetch.post('/cs/review/detail/tag/list/excel/download/selected', data);
  /**
   *  [상품 후기 상세] 선택된 태그 리스트 엑셀 업로드
   */
  setCsReviewDetailTagExcelUpload = (data) => SuperFetch.post('/cs/review/detail/tag/list/excel/upload', data);
  /**
   *  [상품 후기 등록] 상품의 연결된 태그 리스트 데이터 요청하기
   */
  getProductTagList = (data) => SuperFetch.post('/cs/review/insert/preparation/product/tag/list', data);
}

export default new CsReviewApi();
